import { SxProps } from "@mui/material";
import { typographySx } from "app/styles/muiTypograpthySx";

export const styles: {
    [key: string]: SxProps;
} = {
    root: {
        display: "flex",
        justifyContent: "space-between",
        border: "none",
        py: 1,
        px: 2
    },
    rootCompact: {
        display: "flex",
        flexDirection: "column",
        gap: 1,
        justifyContent: "space-between",
        border: "none",
        py: 1
    },
    rootChild: {
        display: "flex"
    },
    leftText: {
        my: "auto",
        color: "greyscale.900",
        ...typographySx.bodyP4,
        fontWeight: 500
    },
    searchInput: {
        minWidth: 270
    },
    searchInputCompact: {
        flex: 1,
        minWidth: 0
    },
    chevronIcon: {
        width: "8px",
        height: "8px"
    },
    clearButton: {
        width: 10,
        height: 10
    },
    infoIcon: {
        width: 16,
        height: 16
    },
    controlLabel: {
        "& > :first-child": {
            padding: 2,
            borderBottom: ({ palette }) => `1px solid ${palette.greyscale[200]}`
        }
    },
    advancedOptionsContainer: {
        width: "368px",
        zIndex: ({ zIndex }) => zIndex.modal + 1
    },
    advancedOptionsPaper: {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100vh - 200px)"
    },
    advancedOptionsContent: {
        flex: 1,
        minHeight: 0,
        overflowY: "auto"
    },
    borderTop: {
        borderTop: ({ palette }) => `1px solid ${palette.greyscale[200]}`
    }
};
